export default __webpack_public_path__ + "static/media/r12.a5e4d20c.jpg";